// Declared in the order the groups are shown in the campaign select
export const IberiaCardsCampaignGroup = {
  INDIVIDUALS: 'INDIVIDUALS',
  IBERIA_EMPLOYEES: 'IBERIA_EMPLOYEES',
  CORPORATE_GROUPS: 'CORPORATE_GROUPS',
} as const;

export type IberiaCardsCampaignGroupValue = (typeof IberiaCardsCampaignGroup)[keyof typeof IberiaCardsCampaignGroup];

export interface IberiaCardsCampaign {
  id: string;
  campaign: string;
  product: string;
  avios: number;
  customerType: number;
  cardProduct: number;
  cardBrand: number;
  cardType: number;
  corporateGroup?: number;
  description: string;
  group: IberiaCardsCampaignGroupValue;
  comment?: string;
  // Vigencia. ISO date, YYYY-MM-DD, both ends inclusive.
  // Omitting a bound means there is no boundary on that side:
  //   none          -> always available
  //   validFrom     -> available from that day onwards, indefinitely
  //   validTo       -> available until that day, inclusive
  //   both          -> available only between those days, inclusive
  validFrom?: string;
  validTo?: string;
}
